<template>
  <page :title="i18n.title">
    <div class="balance">
      <div class="balance-title">
        {{ i18n.balance }}
      </div>
      <div class="balance-num">
        {{ wallet ? wallet.pCurrencySymbol : user && user.pcurrencyName
        }}{{ wallet ? wallet.pBalance : (user && user.pbalance) || 0 }}
      </div>
    </div>
    <div class="wallet-out-title">{{ i18n.退款金额 }}</div>
    <div style="padding: 20px">
      <input class="text-area" v-model="price" />
    </div>
    <div class="Full-withdrawal" @click="onAll">{{ i18n.balance_all }}</div>
    <div class="btn">
      <van-button class="bottom-pakage-btn" round @click="onSubmit">{{
        i18n.submit
      }}</van-button>
    </div>
    <!-- <div v-if="checkNeedRemark" class="popup-show-modal">
      <div class="popup-show-modal-main">
        <div class="popup-show-modal-title">{{ i18n.confirmtitle }}</div>
        <div class="popup-show-modal-content">{{ i18n.confirmcontent }}</div>
        <div class="remarkform">
          <span>{{ i18n.payee_name }}:</span>
          <input type="text" v-model.lazy="remark.name" />
        </div>
        <div class="remarkform">
          <span>{{ i18n.payee_bankcard }}:</span>
          <input type="text" v-model.lazy="remark.bankcard" />
        </div>
        <div class="remarkform">
          <span>{{ i18n.payee_phone }}:</span>
          <input type="phone" v-model.lazy="remark.phone" />
        </div>
        <div class="popup-show-modal-btns">
          <div class="cancelbtn" @click="onCancel">{{ i18n.cancelText }}</div>
          <div class="confirmbtn" @click="onConfirm">
            {{ i18n.confirmText }}
          </div>
        </div>
      </div>
    </div> -->
    <van-action-sheet v-model="show" :title="i18n.remark" @close="onClose">
      <van-cell
        is-link
        required
        :title="i18n.bank"
        :value="bankData.name"
        @click="selectshow = true"
      />
      <van-action-sheet
        v-model="selectshow"
        :actions="payoutChannels"
        @select="onSelect"
      />
      <template v-if="payoutConfig && payoutConfig.length > 0">
        <div v-for="(item, index) in payoutConfig" :key="index">
          <template v-if="item.fieldName === 'toBankCode' ? noBankCode : true">
            <template v-if="item.fieldType === 'picker'">
              <van-cell
                is-link
                required
                :title="$t(`column.${item.fieldName}`)"
                :value="apiData[item.fieldName].label"
                @click="
                  payoutConfigSel(item.fieldDefauldValues, item.fieldName)
                "
              />
            </template>
            <template v-else-if="item.fieldType === 'input'">
              <van-field
                required
                input-align="right"
                v-model="apiData[item.fieldName].value"
                :label="item.fieldName"
                :placeholder="item.fieldName"
              />
            </template>
          </template>
        </div>
        <van-action-sheet
          v-model="configshow"
          :actions="pConfig"
          @select="onConfigSelect"
        />
      </template>
      <div class="walletout-popup-btn">
        <button class="btn" @click="onSubmit">{{ i18n.apply }}</button>
      </div>
    </van-action-sheet>
  </page>
</template>

<script>
import { TX_APPLY, TX_POST, REFUND_APPLY } from "../../apis/user.js"
import { mapState } from "vuex"
import { ActionSheet, Cell, Field } from "vant"
export default {
  components: {
    VanActionSheet: ActionSheet,
    VanCell: Cell,
    VanField: Field
  },
  computed: {
    ...mapState(["user", "browser", "wallet"]),
    i18n() {
      return this.$t("wallet_out")
    },
    deposiTips() {
      return `${this.i18n.deposit_tips}`.format(this.user)
    },
    remarkstr() {
      return `姓名:${this.remark.name},银行卡号:${this.remark.bankcard},电话:${this.remark.phone}`
    },
    payWallet() {
      return this.wallet
    }
  },
  data() {
    return {
      key: "",
      price: 0,
      bankData: {
        name: "",
        value: ""
      },
      noBankCode: false,
      apiData: {},
      walletList: [],
      payoutChannels: [], // 支付通道
      payoutConfig: [], // 支付通道下的配置项
      pConfig: [], // 支付通道下的配置项的每项数据
      show: false,
      selectshow: false,
      configshow: false,
      refundTypes: [],
      checkNeedRemark: false,
      NeedRemark: true,
      remark: {
        name: "",
        bankcard: "",
        phone: ""
      }
    }
  },
  methods: {
    onClose() {
      this.show = false
      this.checkNeedRemark = true
    },
    // onCancel() {
    //   console.log(this.remark)
    //   this.checkNeedRemark = !this.checkNeedRemark
    //   this.NeedRemark = true
    //   this.remark = {
    //     name: "",
    //     bankcard: "",
    //     phone: ""
    //   }
    // },
    onConfirm() {
      let bool = this.remark
      if (bool.name && bool.bankcard && bool.phone) {
        this.onSubmit()
        this.checkNeedRemark = !this.checkNeedRemark
        return
      }
      this.$toast(this.i18n.msg_fail_submit)
    },
    onAll() {
      if (this.wallet) {
        this.price = this.wallet.pBalance
      } else if (this.user && this.user.pbalance) {
        this.price = this.user.pbalance
      }
    },
    onSubmit() {
      if (isNaN(this.price) || this.price <= 0) {
        this.$toast(this.i18n.msg_fail_price)
      } else if (this.wallet && this.price > this.wallet.pBalance) {
        this.$toast(this.i18n.msg_fail_balance)
      } else if (this.price > this.user.pbalance && !this.wallet) {
        this.$toast(this.i18n.msg_fail_balance)
      } else if (this.payWallet) {
        this.refund_apply()
      } else {
        this.$loading(true)
        let url = TX_APPLY
        let param = {
          amount: this.price
        }
        const headers = {}
        if (this.wallet.pCurrencySymbol === "XAF") {
          this.NeedRemark = false
        }
        if (this.payWallet) {
          url = REFUND_APPLY
          headers.headers = { "Content-Type": "application/json;charset=UTF-8" }
          param = {
            refundType: 0,
            amount: this.price,
            amountType: "balance",
            agentId: this.wallet.pDailiId,
            currency: this.wallet.pCurrencyType,
            checkNeedRemark: this.NeedRemark // 当前提现的支付通道不支持提现为false
          }
          if (!param.checkNeedRemark) {
            param.remark = this.remarkstr
            param.refundType = this.refund_types || 0
          }
        }
        if (this.browser) {
          url = `${TX_POST}/${this.price}/all`
          param = {}
        }
        this.$post(
          url,
          param,
          (resp) => {
            this.$loading(false)
            if (this.payWallet) {
              console.log("========", resp.data)
              if (resp.data && resp.data.refundTypes) {
                this.refund_types = resp.data.refundTypes[0]
                if (this.refund_types === 0) {
                  this.NeedRemark = false
                  return this.onSubmit()
                }
              }
              if (resp.data && resp.data.tixianOrderId) {
                let wallet = this.wallet
                wallet.pBalance -= this.price
                this.price = 0
                this.$store.commit("wallet", wallet)
                this.$toast(this.i18n.msg_success_content)
              } else {
                this.checkNeedRemark = !this.checkNeedRemark
                this.NeedRemark = false
              }
              return
            }
            this.$toast(this.i18n.msg_success_content)
            this.$store.commit("user", {
              ...this.user,
              pbalance: this.user.pbalance - this.price
            })
            this.price = 0
            console.log(resp)
          },
          (error) => {
            this.$loading(false)
            this.$confirm({
              title: this.i18n.msg_title,
              content: error,
              showCancel: false,
              confirmText: this.i18n.confirm
            })
          },
          headers
        )
      }
    },
    refund_apply() {
      let that = this
      let url = REFUND_APPLY
      let param = {
        agentId: this.wallet.pDailiId,
        amount: this.price,
        amountType: "balance",
        checkNeedRemark: this.checkNeedRemark,
        remark: "1"
      }
      let info = {}
      if (!this.checkNeedRemark && this.show) {
        for (const key in that.apiData) {
          let d = that.apiData[key]
          console.log("d=====", d)
          if (d.value) {
            info[key] = d.value
          } else {
            that.$toast("All information is required")
            throw new Error("所有信息必填")
          }
        }
        param.autoAudit = true
        param.refundTyp = 2
        param.receiverAccount = {
          paymentId: that.bankData.value,
          accountData: {
            ...info
          }
        }
      } else if (this.refundTypes && this.refundTypes.includes(0)) {
        param.autoAudit = true
      }
      console.log("参数======", param)
      this.$loading(true)

      this.$post(
        url,
        {
          ...param
        },
        (resp) => {
          this.$loading(false)
          let that = this
          this.refundTypes = resp.data.refundTypes
          if (
            this.refundTypes &&
            this.refundTypes.includes(0) &&
            this.checkNeedRemark
          ) {
            this.checkNeedRemark = !this.checkNeedRemark
            this.refund_apply()
            return
          }
          if (resp.data && this.checkNeedRemark) {
            this.show = true
            if (
              resp.data.payoutChannels &&
              resp.data.payoutChannels.length > 0
            ) {
              let arr = []
              resp.data.payoutChannels.forEach((v) => {
                let obj = {
                  name: v.channelName,
                  value: v.paymentId,
                  payoutConfig: v.payoutConfig
                }
                arr.push(obj)
                if (v.payoutConfig && v.payoutConfig.length > 0) {
                  v.payoutConfig.forEach((v) => {
                    that.apiData[v.fieldName] = {
                      label: "",
                      value: ""
                    }
                  })
                }
              })
              this.payoutChannels = arr
              console.log("apidata===", this.apiData)
            }
          } else if (resp.data && !resp.data.tixianOrderId) {
            this.refund_apply()
          } else {
            let wallet = JSON.parse(JSON.stringify(this.wallet))
            wallet.pBalance -= this.price
            this.$store.commit("wallet", wallet)
            this.price = 0
            this.$toast(this.i18n.msg_success_content)
            this.show = false
          }
          console.log(resp)
          this.checkNeedRemark = !this.checkNeedRemark
        },
        (error) => {
          this.$loading(false)
          let errstr = ""
          if (error.includes("余额不足")) {
            errstr = this.i18nMsg.msg_fail_balance
          } else {
            errstr = error
          }
          this.$confirm({
            title: this.i18n.msg_title,
            content: errstr,
            showCancel: false,
            confirmText: this.i18n.confirm
          })
        },
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          }
        }
      )
    },
    onSelect(action, index) {
      console.log("onSelect===", action, index)
      this.bankData.name = action.name
      this.bankData.value = action.value
      this.payoutConfig = action.payoutConfig
      this.selectshow = false
    },
    payoutConfigSel(arr, key) {
      console.log("payoutConfigSel===", arr)
      this.key = key
      let array = []
      arr.forEach((v) => {
        let obj = {
          name: v.desc,
          value: v.value
        }
        array.push(obj)
      })
      let list = []
      if (arr.length > 0 && this.apiData["transType"] && key === "proxyType") {
        let pvalue = this.apiData["transType"].value
        list = arr.filter((v) => {
          if (v.desc.indexOf(pvalue) !== -1) {
            v.name = v.desc
            return v
          }
        })
      }
      this.pConfig = key === "proxyType" ? list : array
      this.configshow = true
    },
    onConfigSelect(action, index) {
      console.log("onConfigSelect====", action, index, this.key)
      this.apiData[this.key].label = action.name
      this.apiData[this.key].value = action.value
      if (this.key === "transType") {
        this.apiData["proxyType"] = {
          label: "",
          value: ""
        }
      }
      if (this.key === "proxyType") {
        if (action.value === "10") {
          this.apiData["toBankCode"] = {
            label: "",
            value: ""
          }
          this.noBankCode = true
        } else {
          delete this.apiData.toBankCode
          this.noBankCode = false
        }
      }
      this.configshow = false
    }
  },
  created() {
    console.log("wallet", this.wallet)
  }
}
</script>

<style lang="less" scoped>
.text-area {
  width: 100%;
  height: 80px;
  background: rgb(255, 255, 255);
  border-radius: 18px;
  opacity: 1;
  border: 2px solid rgb(209, 209, 209);
  font-size: 60px;
  line-height: 1;
  text-align: center;
}
.btn {
  margin: 40px;

  .bottom-pakage-btn {
    background: linear-gradient(132deg, #1a2229 0%, #00ab46 100%);
    box-shadow: 0px 6px 10px 1px rgba(0, 171, 70, 0.2);
    border-radius: 60px 60px 60px 60px;
    padding: 23px 73px;
    color: #fff;
    width: 100%;
    font-size: 36px;
    font-family: Work Sans-Bold, Work Sans;
    font-weight: bold;
  }
}
.Full-withdrawal {
  font-size: 22px;
  font-family: Work Sans-Regular, Work Sans;
  color: #00ab46;
  text-align: center;
  line-height: 2;
}
/deep/.van-search .van-cell {
  background: #fff;
}
/deep/.van-field__left-icon {
  // display: none;
  margin-right: 20px;
  .van-icon-search {
    display: none;
  }
}
.wallet-out-title {
  font-size: 32px;
  font-family: Montserrat-Bold, Montserrat;
  font-weight: bold;
  color: #1a2229;
  padding: 20px 40px;
}
.balance {
  background: url("../../assets/imgs/img_dollar_2@2x.png") no-repeat center;
  background-size: cover;
  width: 96%;
  height: 3.1rem;
  margin: 0 auto;
  color: #ffffff;
  font-family: Work Sans-Medium, Work Sans;

  &-title {
    font-size: 32px;
    padding: 20px 30px;
  }

  &-num {
    font-size: 60px;
    font-weight: bold;
    text-align: center;
    padding: 10px 0 35px 0;
  }
}
.popup-show-modal {
  z-index: 99999;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.3);
  &-main {
    width: 80%;
    min-height: 220px;
    background-color: #fff;
    border-radius: 16px;
    color: #161616;
    text-align: center;
    border: 2px solid #dcdfe6;
    padding-bottom: 100px;
    position: relative;
    .remarkform {
      margin-bottom: 20px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-right: 0.5rem;
      span {
        width: 30%;
        text-align: start;
        font-weight: bold;
        margin: 0px 0 10px 25px;
      }
      input {
        border: solid 1px #ccc;
        border-radius: 10px;
        outline: none;
        padding: 0 10px;
        height: 40px;
        width: 60%;
      }
    }
  }
  &-title {
    font-size: 32px;
    line-height: 80px;
  }
  &-content {
    font-size: 28px;
    line-height: 40px;
    padding: 20px;
  }
  &-btns {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 80px;
    line-height: 80px;
    font-size: 28px;
    border-top: 2px solid #dcdfe6;
    display: flex;
    justify-content: flex-start;
    margin-top: 10px;
    div {
      flex: 1;
    }
    div + div {
      border-left: 2px solid #dcdfe6;
    }
    .cancelbtn {
      color: #000000;
    }
    .confirmbtn {
      color: #00ce70;
    }
  }
}
.walletout-popup-textarea {
  display: block;
  width: 85%;
  margin: 0 auto;
  border-radius: 20px;
  outline: none;
  padding: 10px;
}
.walletout-popup-btn {
  width: 85%;
  margin: 40px auto;
  button {
    width: 100%;
    border: none;
    padding: 0;
    margin: 0;
  }
}
</style>
